import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { delay, map } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { AuthService } from '../services/auth.service';
import { session } from '../common/session/session';
import { IUserTimeTracking, IUserTimeTrackingInfo } from '../common/user-screen-time';
import { GlobalService } from '../services/common/global.service';
import { UserLogsService } from '../services/user-logs/user-logs.service';

@Injectable({
  providedIn: 'root'
})
export class canActivateGuard implements CanActivate {
  private platformId = inject(PLATFORM_ID);

  constructor(
    private authService: AuthService,
    private globalSeervice: GlobalService,
    private router: Router,
    private userlogService : UserLogsService
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    // ✅ PUBLIC ROUTE — SAB SE PEHLE
    if (state.url.startsWith('/onlineconsent')) {
      return of(true);
    }
    // if (state.url.startsWith('/dashboard/caremanager/patient-profile')) {
    //   return of(true);
    // }

    const isBrowser = isPlatformBrowser(this.platformId);
    if (!isBrowser) {
      return of(false);
    }

    const isLoggedIn = this.authService.isLoggedIn();

    if (!isLoggedIn) {
      // ❌ navigate mat karo
      // ✅ UrlTree return karo
      return of(this.router.createUrlTree(['/']));
    }

    const isAuthorized = this.authService.isURLAssigned(state.url);
    if (!isAuthorized) {
      return of(this.router.createUrlTree(['/401']));
    }

    // ✅ Authorized user
    this.userlogService.updateLastVisitTime(state.url);
    localStorage.setItem(this.authService.userLastRoute, state.url);

    return of(true);
  }
  
}

